import HttpService from "./HttpService";
import store from '../store/store';

export default class BaseSerasaService extends HttpService{

    constructor(props) {
        super(props);
        this._headers = {
            'Content-Type': 'application/json',
            'Authorization':'Bearer '+store.getters.dados.t1n
        };
    }

    consultarCanaisDigitais(){
        let dados = (({ id_link,tempo_resposta }) => ({ id_link,tempo_resposta }))(store.getters.dados);
        dados.selfie = sessionStorage.getItem('s');
        dados.selfie_msg = sessionStorage.getItem('selfie_msg');
        dados.selfie_id = sessionStorage.getItem('selfie_id');
        return  this._post('base-serasa-rest/consultarBase1N',dados);
    }
}



// WEBPACK FOOTER //
// ./src/services/BaseSerasaService.js